<template>
  <v-dialog
    v-if="!dialogVisibleCreateActivity"
    v-model="show"
    width="70%"
    overlay-color="darktext"
    overlay-opacity="0.6"
    content-class="content-create-template-dialog"
    @click:outside="closeDialog"
  >
    <v-card style="margin-top:-72px" color="background">
      <v-row
        no-gutters
        style="position:relative;top:72px"
      >
        <v-spacer />
        <v-icon
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          class="rounded-xxl text-none ma-6"
          @click="show=false"
        >
          mdi-close
        </v-icon>
      </v-row>
      <v-row no-gutters>
        <v-col
          align="center"
          offset-sm="1"
          offset-md="1"
          :cols="mobile() ? '12' : '5'"
          :class="mobile() ? '' : ' pr-16 my-16'"
        >
          <CreateContentTemplate
            data-testid="create-activity"
            :page-title="$t('createContentTemplateTitleActivity')"
            :page-text="$t('createContentTemplateTextActivity')"
            page-image="create-activity"
            :page-create-btn="$t('create')"
            @proceedSubmit="createActivity"
          />
        </v-col>
        <v-divider vertical />
        <v-col
          align="center"
          :cols="mobile() ? '12' : '5'"
          :class="mobile() ? '' : 'pl-16 my-16'"
        >
          <CreateContentTemplate
            data-testid="create-hub"
            :page-title="$t('createContentTemplateTitleHub')"
            :page-text="$t('createContentTemplateTextHub')"
            page-image="create-hub"
            :page-create-btn="$t('create')"
            @proceedSubmit="createHub"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
  <ConfirmationDialogCreateActivity 
    v-else
    :visible="dialogVisibleCreateActivity" 
    data-testid="create-activity" 
    @close="closeDialog"
    @proceedSubmit="createActivityMsg"
  />
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import CreateContentTemplate from './CreateContentTemplate'
import ConfirmationDialogCreateActivity from './ConfirmationDialogCreateActivity'

export default {
    components: {
     CreateContentTemplate,
     ConfirmationDialogCreateActivity
  },
  mixins: [repeatedMethodsMixin],
  props: {
    visible: Boolean,
    id: {
      type: Number,
      default: 0
    },
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
  },
  data(){
    return{
      dialogVisibleCreateActivity: false
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
         
      }
    }
  },
    methods: {
        createActivity(){
          this.dialogVisibleCreateActivity = true
        },
        createHub(){
            this.$router.push({path: '/hub/create'})
        },
        closeDialog() {
            this.$emit('close')
        },
        createActivityMsg(msg, type){
            this.$emit('proceedSubmit', msg, type)
        },
        
        
    },
}
</script>